import { post, get } from '../../../../services/request';

//-------------------License & Privileges Power Sync - start----------------//
export const getLicensePrivilegesPowerSync = (payload) => {
    return post('LicensePrivilegePowerSync/GetAllLicensePrivilegePowerSync', payload);
};

export const getLicensePrivilegesPowerSyncFilterOptions = () => {
    return get('LicensePrivilegePowerSync/GetFilterOptions');
};

export const exportLicensePrivilegesPowerSync = (url, payload) => {
    return post(url, payload);
};

export const getRadSiteAssignmentNotesById = (radiologistSiteAssignmentId) => {
    return get(`RadSiteAssignmentNotes/GetRadSiteAssignmentNotesByID?radiologistSiteAssignmentID=${radiologistSiteAssignmentId}`);
};

export const getLicenseAndRadSiteAssignmentNotesByProviderId = (radiologistId) => {
    return get(`RadSiteAssignmentNotes/GetLicenseAndRadSiteAssignmentNotesByProviderID?radiologistID=${radiologistId}`);
};

export const addRadSiteAssignmentNote = (payload) => {
    return post('RadSiteAssignmentNotes/AddRadSiteAssignmentNote', payload);
};
//-------------------License & Privileges Power Sync - end----------------//
